<div class="app-store-container">
  <h3>App store content</h3>
  <div class="store-input">
      <div class="store-label">
          <span class="store-icon google-play"></span>
          <span class="p-text-bold">Google Play Store</span>
      </div>
      <input type="text" [(ngModel)]="feature.value.google" 
             (ngModelChange)="onGoogleLinkChange()"
             placeholder="Paste the Google Play Store post link here">
  </div>
  <div class="store-input">
      <div class="store-label">
          <span class="store-icon apple-store"></span>
          <span class="p-text-bold">Apple Store</span>
      </div>
      <input type="text" [(ngModel)]="feature.value.apple" 
             (ngModelChange)="onAppleLinkChange()"
             placeholder="Paste the Apple Store post link here">
  </div>
</div>